import type { SortingChapter } from "../sorting/chapters.ts";

/** The ten Logic Tower chapters (10 levels each); same shape as the Sorting chapters. */
export type LogicChapter = SortingChapter;

const chapter = (n: number, themeId: string, name: string, focus: string, palette: readonly [string, string]): LogicChapter => ({
  chapter: n,
  themeId,
  name,
  focus,
  firstLevel: (n - 1) * 10 + 1,
  lastLevel: n * 10,
  palette,
});

/** Every chapter adds exactly one idea (docs/LOGIC_TOWER.md §2). */
export const LOGIC_CHAPTERS: readonly LogicChapter[] = [
  chapter(1, "rolling", "Đường lăn", "Thả bi đúng cột, làm quen cần lật", ["#efe7ff", "#ffeedd"]),
  chapter(2, "levers", "Cần lật", "Nhiều cần hơn, gửi bi đi vòng cho khéo", ["#e8f0ff", "#f4e8ff"]),
  chapter(3, "three", "Ba màu bi", "Tháp rộng hơn, ba màu cùng lúc", ["#fff1df", "#ffe6ee"]),
  chapter(4, "gears", "Bánh răng", "Hai cần chung bánh răng lật cùng nhau", ["#fff5d6", "#ffe9c4"]),
  chapter(5, "lids", "Nắp đồng", "Chén có nắp chờ màu khác đầy trước", ["#e6f6f1", "#efe8ff"]),
  chapter(6, "keyed", "Cần màu", "Cần chỉ lật dưới bi cùng màu", ["#ffecef", "#fff4dc"]),
  chapter(7, "hoppers", "Hai ống chờ", "Chọn cả ống lẫn cột thả", ["#e2f3ff", "#ffeaf4"]),
  chapter(8, "gear-lid", "Bánh răng và nắp", "Bánh răng gặp nắp đồng", ["#ece6ff", "#fff0dc"]),
  chapter(9, "keyed-hoppers", "Cần màu hai ống", "Cần màu gặp hai ống chờ", ["#e3f7ff", "#ffe8f2"]),
  chapter(10, "masterpiece", "Tháp kiệt tác", "Mọi bí kíp trong một tòa tháp", ["#fff0f7", "#e9e6ff"]),
];

export function logicChapterOfLevel(levelId: number): LogicChapter {
  const found = LOGIC_CHAPTERS[Math.floor((levelId - 1) / 10)];
  if (!found) throw new RangeError(`no chapter for level ${levelId}`);
  return found;
}
